import React from 'react';
import './styles.css';
import '../LikeLoaderShimmer/styles.css';
import '../QuestionBankShimmer/styles.css';
import CommonBlockShimmer from '../CommonBlockShimmer';
const NewsFeedShimmer = () =>
{
	return (
		<div className='cardT car-cont bg-white when-NOW p2p style-scope animated_skelton-animate'>
			<CommonBlockShimmer/>
			<div className='flexCol pdngHMD'>
				<div className='shimmerHeader loading-shimmer' />
			</div>
			<div className='flexMinWidthRow'>
				<div className='flexWrap'>
					{[ 1, 2 ].map((e) => (
						<div className='halfWidth' key={e}>
							<div className='mrgnTMD pdngHXXS'>
								<div className='shimmerCardBg '>
									<div className='shimmerCardBG mediaBox' />
								</div>
							</div>
						</div>
					))}

					{[ 1, 2, 3 ].map((e) => (
						<div className='oneThirdWidth' key={e}>
							<div className='mrgnTMD pdngHXXS'>
								<div className='shimmerCardBg '>
									<div className='shimmerCardBG mediaBox' />
								</div>
							</div>
						</div>
					))}

				</div>
			</div>
		</div>
	);
};

export default NewsFeedShimmer;
